import { Alert, Snackbar } from '@mui/material';
import React from 'react'
import { useNotification } from '../../contexts';

export default function NotificationAlert() {
    const { state: notificationState, dispatch } = useNotification();
    const notification = notificationState.notifications 
                        && notificationState.notifications.length 
                        ? notificationState.notifications[0] 
                        : undefined;
  
    const handleClose = () => {
        dispatch({
            type: "add",
            notifications: [],
        });  
    };
  
  return (
    <div>
        {notification && <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
          <Alert
            onClose={handleClose}
            severity={notification.type ? notification.type : "success"}
            sx={{ width: "100%" }}
          >
            {notification.title}
          </Alert>
        </Snackbar>}
    </div>
  )
}
